import { SlideComponent, Splide } from "@splidejs/splide";

import "./gallery-slider.scss";

export class GallerySlider {
    #SELECTOR_SLIDER = '.gallery-slider';
    #SELECTOR_PAGINATION = `${this.#SELECTOR_SLIDER}__pagination`;
    #SELECTOR_PAGINATION_PAGE = `${this.#SELECTOR_PAGINATION} ${this.#SELECTOR_SLIDER}__page`;
    #SELECTOR_PAGINATION_COUNT = `${this.#SELECTOR_PAGINATION} ${this.#SELECTOR_SLIDER}__count`;

    #slider: Splide;
    #paginationPage: HTMLElement;
    #paginationCount: HTMLElement;

    constructor() {
        this.#initElements();
        this.#initEvents();

        this.#slider.mount();

        this.#tweakSlider();
    }

    #initElements(): void {
        this.#slider = new Splide(this.#SELECTOR_SLIDER, {
            perPage: 1,
            focus: 'center',
            gap: 24,
            pagination: false,
            keyboard: true,
            slideFocus: true,
            trimSpace: false,
            mediaQuery: 'min',
            breakpoints: {
                576: {
                    focus: undefined,
                    perPage: 2,
                    trimSpace: true,
                },
                1200: {
                    perPage: 3,
                }
            },
        });

        this.#paginationPage = this.#slider.root.querySelector(this.#SELECTOR_PAGINATION_PAGE);
        this.#paginationCount = this.#slider.root.querySelector(this.#SELECTOR_PAGINATION_COUNT);
    }

    #initEvents(): void {
        this.#slider.on('mounted', () => {
            const perPage = this.#slider.options.perPage;

            this.#paginationPage.textContent = String(Math.ceil(this.#slider.index / perPage) + 1);
            this.#paginationCount.textContent = String(Math.ceil(this.#slider.length / perPage));
        });

        this.#slider.on('move', () => {
            this.#paginationPage.textContent = String(Math.ceil(this.#slider.index / this.#slider.options.perPage) + 1);
        });

        this.#slider.on('updated', () => {
            const perPage = this.#slider.options.perPage;

            this.#paginationPage.textContent = String(Math.ceil(this.#slider.index / perPage) + 1);
            this.#paginationCount.textContent = String(Math.ceil(this.#slider.length / perPage));
        });
    }

    #tweakSlider(): void {
    }
}
